import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MarketplaceThemeService } from '@core/services/marketplace-theme.service';
import { TenantScopeService } from '@core/services/tenant-scope.service';

import { MarketplaceFooterComponent } from '../marketplace-footer/marketplace-footer.component';
import { MarketplaceHeaderComponent } from '../marketplace-header/marketplace-header.component';
import { TenantBandComponent } from '../tenant-band/tenant-band.component';

/**
 * Storefront chrome for every shell page: the sticky translucent header (which
 * owns both of its rows, category links included), the routed page inside
 * <main>, and the footer. A tenant band appears above the header when a
 * branded storefront scope is active.
 */
@Component({
  selector: 'app-marketplace-shell',
  standalone: true,
  imports: [TenantBandComponent, MarketplaceHeaderComponent, MarketplaceFooterComponent],
  templateUrl: './marketplace-shell.component.html',
  styleUrl: './marketplace-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarketplaceShellComponent {
  protected readonly tenantScope = inject(TenantScopeService);

  constructor() {
    // The shell is always mounted, so instantiating the theme service here
    // keeps its tenant-branding effect alive for the whole session (SM-03).
    inject(MarketplaceThemeService);
  }
}
